import { Avatar } from '../components/Dialogs/CreateProfile'


export const API_URL = 'https://api.mujerespazyseguridad.co';
export const GAME_API_URL = 'https://vfbdyszex1.execute-api.sa-east-1.amazonaws.com/dev';
export const GAME_API_KEY ='69sFgQvHxv6ako2ZWl7yQ9FGAG3U2OlA60MZqLAY';
export const GAME_INSTRUCTIVE_PDF='https://mujerespazyseguridad.co/wp-content/uploads/2023/07/INSTRUCTIVO_JUEGO_CAJADEHERRAMIENTAS.pdf'
export const FINAL_BOARD_POSITION = 96;
export const ENDING_BOARD_POSITION = 85;
export const SINGLE_DIE_POSITION = 90;
export const EXPIRY_TIME_IN_SECONDS = 7200;
